import axios from "axios";
import { ApiUrl } from "../data-types/api-client/api-url";

const axiosInstance = axios.create({
  withCredentials: true,
});

let csrfToken: string = "";

export const fetchCsrfToken = async () => {
  const res = await axiosInstance.get<{ csrfToken: string }>(
    ApiUrl.CsrfTokenApiUrl
  );
  csrfToken = res.data.csrfToken;
};

axiosInstance.interceptors.request.use((config) => {
  const methodsWithCSRF = ["post", "put", "patch", "delete"];
  if (csrfToken && config.method && methodsWithCSRF.includes(config.method)) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

export default axiosInstance;
